import { render, staticRenderFns } from "./BlueBox.vue?vue&type=template&id=46c3e508&scoped=true"
import script from "./BlueBox.vue?vue&type=script&lang=js"
export * from "./BlueBox.vue?vue&type=script&lang=js"
import style0 from "./BlueBox.vue?vue&type=style&index=0&id=46c3e508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3e508",
  null
  
)

export default component.exports